import { Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { ChevronLeft } from '@material-ui/icons';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useLoanStore } from '@roc/feature-loans-shared';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router';
import DrawDetailsShared from './drawDetails/drawDetailsShared';
import { useDrawsStore } from './hooks/useDrawsStore';

const useStyles = makeStyles(theme => ({
  container: {
    padding: 32,
  },
  dealName: {
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    padding: 24,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    marginLeft: '-8px',
  },
}));

export const DrawDetails = observer(
  ({ loanId, drawId, adminSpecialist, reviewSpecialist }:
    { loanId: string; drawId: string; adminSpecialist: string; reviewSpecialist: string; }) => {
    const { loanStore } = useLoanStore();
    const { drawStore } = useDrawsStore();
    const { push } = useHistory();
    const { loanRoutesConfig } = useLoanRoutes();
    const classes = useStyles();

    return (
      <>
        <Grid
          container
          direction="column"
          spacing={2}
          className={classes.container}
        >
          <Grid item className={classes.dealName}>
            <Typography variant="h6" color="textSecondary">
              {loanStore?.loanDetails.dealName}
            </Typography>
          </Grid>
          <Grid item className={classes.titleContainer}>
            <IconButton
              aria-label="back"
              color="secondary"
              onClick={() =>
                push(loanRoutesConfig.loans(loanId).children.draws.url)
              }
            >
              <ChevronLeft fontSize="large" />
            </IconButton>
            {drawStore?.currentDraw?.propertyAddress ? (
              <Typography variant="h4" className={classes.title}>
                DRAW {drawStore?.currentDraw.drawNumber} -{' '}
                {drawStore.currentDraw.propertyAddress}
              </Typography>
            ) : (
              <Typography variant="h4" className={classes.title}>
                DRAW {drawStore?.currentDraw?.drawNumber}
              </Typography>
            )}
          </Grid>
          <DrawDetailsShared loanId={loanId} drawId={drawId} adminSpecialist={adminSpecialist} reviewSpecialist={reviewSpecialist} />
        </Grid>
      </>
    );
  }
);
